export function formatDateToHumanFirendly(
  dateStr: string,
  timezone: string
): string {
  const date = new Date(dateStr);
  // Format the date to a human-friendly format
  return date.toLocaleString("en-US", {
    timeZone: timezone, // EDT time zone
    weekday: "short", // Full weekday name
    year: "numeric",
    month: "short", // Full month name
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    // second: 'numeric',
    timeZoneName: "short", // Timezone name like "EDT"
  });
}

export function convertToDateObjectWithTimezone(
  utcTime: string,
  timezone: string
): Date {
  const utcDate = new Date(utcTime);
  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone: timezone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
  const parts = formatter.formatToParts(utcDate);
  const year = parseInt(
    parts.find((part) => part.type === "year")?.value || "0",
    10
  );
  const month =
    parseInt(parts.find((part) => part.type === "month")?.value || "1", 10) - 1;
  const day = parseInt(
    parts.find((part) => part.type === "day")?.value || "1",
    10
  );
  const hour = parseInt(
    parts.find((part) => part.type === "hour")?.value || "0",
    10
  );
  const minute = parseInt(
    parts.find((part) => part.type === "minute")?.value || "0",
    10
  );
  const second = parseInt(
    parts.find((part) => part.type === "second")?.value || "0",
    10
  );
  return new Date(year, month, day, hour, minute, second);
}
export function convertTimeToTimezone(utcTime: any, timezone: any) {
  if (!utcTime) {
    console.error("convertTimeToTimezone: Received undefined or null utcTime.");
    return { time: "Invalid", period: "" };
  }
  
  if (!timezone || typeof timezone !== "string") {
    console.error("convertTimeToTimezone: Received an invalid timezone:", timezone);
    timezone = "UTC"; // Defaulting to UTC as a fallback
  }
  console.log("UTC Time Input:", utcTime);
  console.log("Timezone Input:", timezone);
  const options: Intl.DateTimeFormatOptions = {
    timeZone: timezone,
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  };
  const dateObj = new Date(utcTime);
  if (isNaN(dateObj.getTime())) {
    console.error("convertTimeToTimezone: Invalid Date Object created from", utcTime);
    return { time: "Invalid", period: "" };
  }
  const formatter = new Intl.DateTimeFormat("en-US", options);
  const formattedTime = formatter.format(dateObj);
  console.log("Formatted Time Output:", formattedTime);
  const [time, period] = formattedTime?.split(" ") || ["Invalid", ""];
  return { time, period };
}
export function formatTimestamp(isoString: any) {
  // Create a Date object from the ISO string
  const dateObj = new Date(isoString);
  // Extract date (year, month, day) and create a new Date object
  const formattedDate = new Date(
    dateObj.getUTCFullYear(),
    dateObj.getUTCMonth(),
    dateObj.getUTCDate()
  );
  // Extract time components
  let hours = dateObj.getUTCHours();
  const minutes = String(dateObj.getUTCMinutes()).padStart(2, "0");
  // Determine AM or PM
  const period = hours >= 12 ? "PM" : "AM";
  // Convert 24-hour time to 12-hour format
  hours = hours % 12 || 12;
  // Return formatted values
  return {
    date: formattedDate, // Date object
    hours: hours.toString().padStart(2, "0"),
    minutes,
    period,
  };
}